import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-8 text-center">
      <h1 className="text-4xl font-semibold text-foreground">404</h1>
      <p className="mt-4 text-lg text-foreground/80">
        {t('notFound.message')}
      </p>
      <Button asChild className="mt-8">
        <Link to="/">{t('notFound.goHome')}</Link>
      </Button>
    </div>
  );
}

export default NotFoundPage;
